var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
a:{var Aa=$CLJS.ba.navigator;if(Aa){var Ba=Aa.userAgent;if(Ba){$CLJS.za=Ba;break a}}$CLJS.za=""};